import { normalizeContentRegion } from '@visious/core';

/**
 * §8's `contentRegion`, which Settings owns and this file is the seam for.
 *
 * It is per page origin like every other stored preference, and it is deliberately *not* defaulted
 * to a guess: `null` means "no preference", the request then omits `region=`, and the instance
 * answers with its own default. A region inferred from `navigator.language` would silently change
 * what Trending shows based on a browser setting the reader never connected to content.
 *
 * Reading it goes through core's allowlist, so a value left behind by an older build — or typed into
 * `localStorage` by hand — cannot reach the wire and 500 the page (`feed/region.ts`).
 */
const REGION_KEY = 'visious.region';

export function readContentRegion(): string | null {
  try {
    return normalizeContentRegion(globalThis.localStorage.getItem(REGION_KEY));
  } catch {
    // Storage can throw outright in a partitioned context. That is "no preference", not a failure.
    return null;
  }
}

/** Returns what was actually stored — `null` when the code was refused, so a caller can say so. */
export function writeContentRegion(input: string | null): string | null {
  const region = normalizeContentRegion(input);
  try {
    if (region === null) globalThis.localStorage.removeItem(REGION_KEY);
    else globalThis.localStorage.setItem(REGION_KEY, region);
  } catch {
    return region;
  }
  return region;
}
